// extracted by mini-css-extract-plugin
module.exports = {"Tile":"Tile_Tile__xeRTO","TileLabel":"Tile_TileLabel__aGFCJ","TileValue":"Tile_TileValue__VHVCY","Loading":"Tile_Loading__2XUJ7"};